export default __webpack_public_path__ + "static/media/sticker-f.3d54566a.png";